export const FETCH_AVAILABLE_STORAGES_BEGIN = "FETCH_AVAILABLE_STORAGES_BEGIN";
export const FETCH_AVAILABLE_STORAGES_SUCCESS =
  "FETCH_AVAILABLE_STORAGES_SUCCESS";
export const FETCH_AVAILABLE_STORAGES_FAILURE =
  "FETCH_AVAILABLE_STORAGES_FAILURE";

export const FETCH_AVAILABLE_SKUS_BEGIN = "FETCH_AVAILABLE_SKUS_BEGIN";
export const FETCH_AVAILABLE_SKUS_SUCCESS = "FETCH_AVAILABLE_SKUS_SUCCESS";
export const FETCH_AVAILABLE_SKUS_FAILURE = "FETCH_AVAILABLE_SKUS_FAILURE";

export const RESET_AVAILABLE_SKUS = "RESET_AVAILABLE_SKUS";
